<!-- 首页右边框-主内容 -->
<template>
	<div id="contain" class="main">
		<div>
			<el-row :gutter="24">
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="background-color: transparent;border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 260px;">
							<div class="d-flex align-items-center" style="width: 100%;height: 60px;">
								<div style="font-size: 16px;margin-left: 10px;font-weight: 800;color: #0EFCFF;">今日单据数据
								</div>
							</div>
							<div ref="myCharpath1" class="resize-target"></div>
						</div>
					</div>
				</el-col>
				<el-col :span="16" class="gdt">
					<div style="display: flex;align-items: center;justify-content: center;height: 70px;">
						<div style="padding: 2px;" class="title_web gdt" @click="showFullScreen">
							<div style="color: #0EFCFF;font-size: 14px;">大屏显示</div>
						</div>
						<div style="font-size: 24px;color: #fff;font-weight: 800;margin-left: 20px;margin-right: 20px;">
							大数据中心可视化平台</div>
						<div style="padding: 2px;" class="title_admin gdt">
							<div style="color: #0EFCFF;font-size: 14px;">切换面板</div>
						</div>
					</div>
					<div style="margin-top: 20px;">
						<el-row :gutter="24">
							<el-col :span="12" class="gdt">
								<div style="margin-top: 10px;display: flex;justify-content: center;">
									<div
										style="background-color: transparent;border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 170px;">
										<div class="d-flex align-items-center" style="width: 100%;">
											<div
												style="font-size: 14px;margin-left: 10px;font-weight: 800;color: #0EFCFF;margin-top: 10px;">
												入库看板</div>
										</div>
										<div ref="myCharpath3" class="resize-target"></div>
									</div>
								</div>
							</el-col>
							<el-col :span="12" class="gdt">
								<div style="margin-top: 10px;display: flex;justify-content: center;">
									<div
										style="background-color: transparent;border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 170px;">
										<div class="d-flex align-items-center" style="width: 100%;">
											<div
												style="font-size: 14px;margin-left: 10px;font-weight: 800;color: #0EFCFF;margin-top: 10px;">
												出库看板</div>
										</div>
										<div ref="myCharpath4" class="resize-target"></div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>

				</el-col>
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="background-color: transparent;border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 260px;">
							<div class="d-flex align-items-center" style="width: 100%;height: 60px;">
								<div style="font-size: 16px;margin-left: 10px;font-weight: 800;color: #0EFCFF;">库存数据
								</div>
							</div>
							<div ref="myCharpath2" class="resize-target"></div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 10px;">
			<el-row :gutter="24">
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 90%;height: 50px;display: flex;align-items: center;justify-content: center;background: rgb(252, 255, 255,0.2);flex-flow: column;">
							<div style="font-size: 14px;font-weight: 800;color: #0EFCFF;">{{jrttl.toFixed(2)}}吨</div>
							<div style="color: #0EFCFF;font-size: 10px;">今日吞吐量</div>
						</div>
					</div>
				</el-col>
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 90%;height: 50px;display: flex;align-items: center;justify-content: center;background: rgb(252, 255, 255,0.2);flex-flow: column;">
							<div style="font-size: 14px;font-weight: 800;color: #0EFCFF;">{{yuettl.toFixed(2)}}吨</div>
							<div style="color: #0EFCFF;font-size: 10px;">月吞吐量</div>
						</div>
					</div>
				</el-col>
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 90%;height: 50px;display: flex;align-items: center;justify-content: center;background: rgb(252, 255, 255,0.2);flex-flow: column;">
							<div style="font-size: 14px;font-weight: 800;color: #0EFCFF;">254</div>
							<div style="color: #0EFCFF;font-size: 10px;">今日单据数据</div>
						</div>
					</div>
				</el-col>
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 90%;height: 50px;display: flex;align-items: center;justify-content: center;background: rgb(252, 255, 255,0.2);flex-flow: column;">
							<div style="font-size: 14px;font-weight: 800;color: #0EFCFF;">35</div>
							<div style="color: #0EFCFF;font-size: 10px;">今日单据数据</div>
						</div>
					</div>
				</el-col>
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 90%;height: 50px;display: flex;align-items: center;justify-content: center;background: rgb(252, 255, 255,0.2);flex-flow: column;">
							<div style="font-size: 14px;font-weight: 800;color: #0EFCFF;">78</div>
							<div style="color: #0EFCFF;font-size: 10px;">今日单据数据</div>
						</div>
					</div>
				</el-col>
				<el-col :span="4" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 90%;height: 50px;display: flex;align-items: center;justify-content: center;background: rgb(252, 255, 255,0.2);flex-flow: column;">
							<div style="font-size: 14px;font-weight: 800;color: #0EFCFF;">{{ccbfb}}%</div>
							<div style="color: #0EFCFF;font-size: 10px;">仓库储能</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 10px;" v-if="qhmb == 0">
			<el-row :gutter="24">
				<el-col :span="12" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 200px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">7天库存趋势</div>
							<div ref="myCharpath_kc7" class="resize-target"></div>
						</div>
					</div>
				</el-col>

				<el-col :span="12" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 200px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">30日库存趋势</div>
							<div ref="myCharpath_kc30" class="resize-target"></div>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="24" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 99%;height: 280px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">全年库存趋势</div>
							<div ref="myCharpath5" class="resize-target"></div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- <div style="margin-top: 10px;" v-if="qhmb == 1">
			<el-row :gutter="24">
				<el-col :span="16" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 160px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">30天库存趋势</div>
							<div ref="myCharpath5" class="resize-target"></div>
						</div>
					</div>
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 160px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">全年库存趋势</div>
							<div ref="myCharpath6" class="resize-target"></div>
						</div>
					</div>
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 160px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">总量库存趋势</div>
							<div ref="myCharpath7" class="resize-target"></div>
						</div>
					</div>
				</el-col>

				<el-col :span="8" class="gdt">
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 160px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">7日库存趋势</div>
							<div ref="myCharpath8" class="resize-target"></div>
						</div>
					</div>
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 160px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">库区存放占比</div>
							<div ref="myCharpath9" class="resize-target"></div>
						</div>
					</div>
					<div style="margin-top: 10px;display: flex;justify-content: center;">
						<div
							style="border: 1px solid #0EFCFF;border-radius: 6px;width: 98%;height: 160px;background-color: transparent;padding: 10px;">
							<div style="color: #0EFCFF;font-size: 12px;">库区出入库频率</div>
							<div ref="myCharpath10" class="resize-target"></div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div> -->
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	import 'echarts/map/js/china.js';
	import moment from 'moment';
	import * as vueEcharts from "echarts";
	let echarts = require('echarts');
	export default {
		data() {
			return {
				qhmb: 0,
				maxHeight: 10,
				day: '',
				myChart: null,
				moment,
				xxtz: [],
				xxtzclz: [],
				bm: 0,
				qx: true,
				gglist: [],
				sfzxa: [],
				sy_cklist: [],
				ccbfb: 0,
				jrttl: 0,
				yuettl: 0,
				sy_cklslist_rc_7: [],
				sy_cklslist_cc_7: [],
				sy_cklslist_rc_15: [],
				sy_cklslist_cc_15: [],
				sy_cklslist_rc_30: [],
				sy_cklslist_cc_30: [],
				sfzxb: [],
				cczx: [],
				cczxb: [],
				mb_ddlist: {
					rcdd: [],
					ccdd: []
				},
				sy_ddlist: {},
				sfdp: 0,
				daylist: [],
				daylist_yue: [],
				daylist_seve: [],
				myCharpath1: {},
				myCharpath1_a: {},
				myCharpath2: {},
				myCharpath2_a: {},
				myCharpath3: {},
				myCharpath3_a: {},
				myCharpath4: {},
				myCharpath4_a: {},
				myCharpath5: {},
				myCharpath5_a: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10%',
						left: '2%',
						right: '3%',
						bottom: '18%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '2011',
							type: 'bar',
							data: [18203, 23489, 29034, 104970, 131744, 131744, 630230]
						},
						{
							name: '2012',
							type: 'bar',
							data: [19325, 23438, 31000, 121594, 134141, 131744, 681807]
						}
					]
				},
				myCharpath6: {},
				myCharpath6_a: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10%',
						left: '2%',
						right: '3%',
						bottom: '18%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '2011',
							type: 'bar',
							data: [18203, 23489, 29034, 104970, 131744, 131744, 630230]
						},
						{
							name: '2012',
							type: 'bar',
							data: [19325, 23438, 31000, 121594, 134141, 131744, 681807]
						}
					]
				},
				myCharpath7: {},
				myCharpath7_a: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10%',
						left: '2%',
						right: '3%',
						bottom: '18%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '2011',
							type: 'bar',
							data: [18203, 23489, 29034, 104970, 131744, 131744, 630230]
						},
						{
							name: '2012',
							type: 'bar',
							data: [19325, 23438, 31000, 121594, 134141, 131744, 681807]
						}
					]
				},
				myCharpath8: {},
				myCharpath8_a: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10%',
						left: '2%',
						right: '3%',
						bottom: '18%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '2011',
							type: 'bar',
							data: [18203, 23489, 29034, 104970, 131744, 131744, 630230]
						},
						{
							name: '2012',
							type: 'bar',
							data: [19325, 23438, 31000, 121594, 134141, 131744, 681807]
						}
					]
				},
				myCharpath9: {},
				myCharpath9_a: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10%',
						left: '2%',
						right: '3%',
						bottom: '18%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '2011',
							type: 'bar',
							data: [18203, 23489, 29034, 104970, 131744, 131744, 630230]
						},
						{
							name: '2012',
							type: 'bar',
							data: [19325, 23438, 31000, 121594, 134141, 131744, 681807]
						}
					]
				},
				myCharpath10: {},
				myCharpath10_a: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10%',
						left: '2%',
						right: '3%',
						bottom: '18%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '2011',
							type: 'bar',
							data: [18203, 23489, 29034, 104970, 131744, 131744, 630230]
						},
						{
							name: '2012',
							type: 'bar',
							data: [19325, 23438, 31000, 121594, 134141, 131744, 681807]
						}
					]
				},
				myCharpath_kc7: {},
				myCharpath_kc7a: {},
				myCharpath_kc30: {},
				myCharpath_kc30a: {},
			};
		},
		// 动态计算过滤器，计算col-3百分比分配页面
		filters: {

		},
		computed: {
			// 引入store-modules的user模块里面的user(存储用户相关的数据)
			...mapState({
				user: state => state.user.user,
				navBar: state => state.menu.navBar
			})
		},
		// 生命周期
		created() {

		},
		// dom渲染完毕 mounted生命周期
		mounted() {
			const now = new Date();
			const year = now.getFullYear();
			const month = now.getMonth() + 1; // 月份从0开始，需要加1
			const day = now.getDate();
			const today = year + '-' + month + '-' + day
			this.changeRecent()
			this.axios.post('/admin/sy_ddlist', { today: today }, { token: true })
				.then(res => {
					this.sy_ddlist = res.data.data;
					let that = this
					this.myCharpath1_a = {
						tooltip: {
							trigger: 'item'
						},
						legend: {
							top: 'top',
							textStyle: {
								color: '#fff'
							}
						},
						series: [{
							name: '数量',
							type: 'pie',
							radius: ['30%', '60%'],
							avoidLabelOverlap: false,
							label: {
								show: false,
								position: 'center'
							},
							emphasis: {
								label: {
									show: true,
									fontSize: 40,
									fontWeight: 'bold'
								}
							},
							labelLine: {
								show: false
							},
							data: [{
									value: that.sy_ddlist.rcdd,
									name: '入仓单'
								},
								{
									value: that.sy_ddlist.ccdd,
									name: '出仓单'
								},
								{
									value: that.sy_ddlist.fhdd,
									name: '发货单'
								}
							]
						}]
					}
					
					this.axios.post('/admin/mb_ddlist', { today: today }, { token: true })
						.then(res => {
							let data = res.data.data;
							let rcdd = []
							for (let c of this.daylist_seve) {
								let rc_num = 0
								let cc_num = 0
								for (let e of data) {
									if (e.create_time.slice(5, 10) == c) {
										rc_num += e.rc
										cc_num += e.cc
									}
								}
								this.mb_ddlist.rcdd.push(rc_num)
								this.mb_ddlist.ccdd.push(cc_num)
							}
					
							this.myCharpath3_a = {
								tooltip: {
									trigger: 'axis',
									axisPointer: {
										type: 'shadow'
									}
								},
								grid: {
									top: '10%',
									left: '5%',
									right: '7%',
									bottom: '18%',
									containLabel: true
								},
								xAxis: [{
									type: 'category',
									data: that.daylist_seve,
									axisTick: {
										alignWithLabel: true
									}
								}],
								yAxis: [{
									type: 'value'
								}],
								series: [{
									name: 'Direct',
									type: 'bar',
									barWidth: '60%',
									data: that.mb_ddlist.rcdd
								}]
							}
							this.myCharpath4_a = {
								tooltip: {
									trigger: 'axis',
									axisPointer: {
										type: 'shadow'
									}
								},
								grid: {
									top: '10%',
									left: '5%',
									right: '7%',
									bottom: '18%',
									containLabel: true
								},
								xAxis: [{
									type: 'category',
									data: that.daylist_seve,
									axisTick: {
										alignWithLabel: true
									}
								}],
								yAxis: [{
									type: 'value'
								}],
								series: [{
									name: 'Direct',
									type: 'bar',
									barWidth: '60%',
									data: that.mb_ddlist.ccdd
								}]
							}
					
							this.axios.post('/admin/sy_cklist', {}, { token: true })
								.then(res => {
									let data = res.data.data;
									this.sy_cklist = data.map(item => {
										let num = 0
										for (let i of item.kclist) {
											num += parseFloat(i.tj)
										}
										return {
											name: item.name,
											ck_num: (parseFloat(item.zdrl) - num).toFixed(2),
											zdrl: parseFloat(item.zdrl),
											num: num
										}
									})
									let ycc = 0
									let zkc = 0
									for (let cc of this.sy_cklist) {
										ycc += cc.num
										zkc += cc.zdrl
									}
									this.ccbfb = (ycc / zkc * 100).toFixed(2)
					
									this.myCharpath2_a = {
										tooltip: {
											trigger: 'axis',
											axisPointer: {
												type: 'shadow'
											}
										},
										legend: {
											top: 'top',
											textStyle: {
												color: '#fff'
											}
										},
										grid: {
											left: '3%',
											right: '8%',
											bottom: '24%',
											containLabel: true
										},
										xAxis: {
											type: 'value'
										},
										yAxis: {
											type: 'category',
											data: [that.sy_cklist[0].name, that.sy_cklist[1].name]
										},
										series: [{
												name: '已存空间',
												type: 'bar',
												stack: 'total',
												label: {
													show: true
												},
												emphasis: {
													focus: 'series'
												},
												data: [that.sy_cklist[0].num, that.sy_cklist[1].num]
											},
											{
												name: '可存空间',
												type: 'bar',
												stack: 'total',
												label: {
													show: true
												},
												emphasis: {
													focus: 'series'
												},
												data: [that.sy_cklist[0].ck_num, that.sy_cklist[1]
													.ck_num
												]
											}
										]
									}
									this.axios.post('/admin/sy_cklslist', {}, {
											token: true
										})
										.then(res => {
											let list_7 = res.data.data.yue_7;
											let list_15 = res.data.data.yue_15;
											let list_30 = res.data.data.yue_30;
											let index = 0
											for (let c of this.daylist_yue) {
												let rc_num_7 = 0
												let cc_num_7 = 0
												let rc_num_15 = 0
												let cc_num_15 = 0
												let rc_num_30 = 0
												let cc_num_30 = 0
												for (let e of list_30) {
													if (e.create_time.slice(5, 10) == c) {
														if (index < 7) {
															rc_num_7 += e.rc
															cc_num_7 += e.cc
															rc_num_15 += e.rc
															cc_num_15 += e.cc
															rc_num_30 += e.rc
															cc_num_30 += e.cc
														} else if (index < 15) {
															rc_num_15 += e.rc
															cc_num_15 += e.cc
															rc_num_30 += e.rc
															cc_num_30 += e.cc
														} else if (index < 30) {
															rc_num_30 += e.rc
															cc_num_30 += e.cc
														}
													}
													// 今天
													if (e.create_time.slice(5, 10) == this.daylist[0]) {
														let zds = e.js * parseFloat(e.mjzl) / 1000
														this.jrttl += zds
													}
					
												}
												this.sy_cklslist_rc_7.push(rc_num_7)
												this.sy_cklslist_cc_7.push(cc_num_7)
												this.sy_cklslist_rc_15.push(rc_num_15)
												this.sy_cklslist_cc_15.push(cc_num_15)
												this.sy_cklslist_rc_30.push(rc_num_30)
												this.sy_cklslist_cc_30.push(cc_num_30)
												index += 1
											}
											console.log(this.sy_cklslist_cc_30)
											for (let all of list_30) {
												let tts = all.js * parseFloat(all.mjzl) / 1000
												this.yuettl += tts
											}
					
											this.myCharpath_kc7a = {
												tooltip: {
													trigger: 'axis',
													axisPointer: {
														type: 'cross',
														label: {
															backgroundColor: '#6a7985'
														}
													}
												},
												legend: {
													data: ['入仓数量','出仓数量'],
													top: 'top',
													textStyle: {
														color: '#fff'
													}
												},
												grid: {
													left: '3%',
													right: '4%',
													bottom: '3%',
													containLabel: true
												},
												xAxis: [{
													type: 'category',
													boundaryGap: false,
													data: that.daylist_seve
												}],
												yAxis: [{
													type: 'value'
												}],
												series: [{
														name: '入仓数量',
														type: 'line',
														stack: 'Total',
														areaStyle: {},
														emphasis: {
															focus: 'series'
														},
														data: that.sy_cklslist_rc_7
													},
													{
														name: '出仓数量',
														type: 'line',
														stack: 'Total',
														areaStyle: {},
														emphasis: {
															focus: 'series'
														},
														data: that.sy_cklslist_cc_7
													}
												]
											}
											this.myCharpath_kc30a = {
												tooltip: {
													trigger: 'axis',
													axisPointer: {
														type: 'cross',
														label: {
															backgroundColor: '#6a7985'
														}
													}
												},
												legend: {
													data: ['入仓数量','出仓数量'],
													top: 'top',
													textStyle: {
														color: '#fff'
													}
												},
												grid: {
													left: '3%',
													right: '4%',
													bottom: '3%',
													containLabel: true
												},
												xAxis: [{
													type: 'category',
													boundaryGap: false,
													data: that.daylist_yue
												}],
												yAxis: [{
													type: 'value'
												}],
												series: [{
														name: '入仓数量',
														type: 'line',
														stack: 'Total',
														areaStyle: {},
														emphasis: {
															focus: 'series'
														},
														data: that.sy_cklslist_rc_30
													},
													{
														name: '出仓数量',
														type: 'line',
														stack: 'Total',
														areaStyle: {},
														emphasis: {
															focus: 'series'
														},
														data: that.sy_cklslist_cc_30
													}
												]
											}
											// 画图
											this.drawLine()
										}
									)
								}
							)
						}
					)
				}
			)
		},
		// 画统计图方法
		methods: {
			// 近15日
			changeRecent() {
				for (let i = 0; i < 7; i++) {
					this.daylist_seve.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('MM-DD'))
				}
				for (let i = 0; i < 15; i++) {
					this.daylist.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('MM-DD'))
				}
				for (let i = 0; i < 30; i++) {
					this.daylist_yue.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('MM-DD'))
				}
			},
			// 刷新按钮
			updateData() {
				// this.myCharpath1_a.series[0].data = [{
				// 		value: 20480,
				// 		name: '入仓单'
				// 	},
				// 	{
				// 		value: 7350,
				// 		name: '出仓单'
				// 	},
				// 	{
				// 		value: 5800,
				// 		name: '发货单'
				// 	},
				// 	{
				// 		value: 4840,
				// 		name: '调货单'
				// 	}
				// ]
				// 重新设置配置项和数据
				this.myCharpath1.setOption(this.myCharpath1_a);
				this.myCharpath2.setOption(this.myCharpath2_a);
				this.myCharpath3.setOption(this.myCharpath3_a);
				this.myCharpath4.setOption(this.myCharpath4_a);
				this.myCharpath5.setOption(this.myCharpath5_a);
				// this.myCharpath6.setOption(this.myCharpath6_a);
				// this.myCharpath7.setOption(this.myCharpath7_a);
				// this.myCharpath8.setOption(this.myCharpath8_a);
				// this.myCharpath9.setOption(this.myCharpath9_a);
				// this.myCharpath10.setOption(this.myCharpath10_a);

				this.myCharpath_kc7.setOption(this.myCharpath_kc7a);
				this.myCharpath_kc30.setOption(this.myCharpath_kc30a);

			},
			// 清除图表实例
			// beforeDestroy() {
			// 	let myCharpath1 = echarts.init();
			// 	let myCharpath2 = echarts.init(this.$refs.myCharpath2);
			// 	this.$refs.myCharpath1.dispose();
			// 	this.$refs.myCharpath2.dispose();
			// 	console.log(myCharpath2)
			// },
			// 全屏
			showFullScreen() {
				if (this.sfdp == 0) {
					var full = document.getElementById("contain");
					this.launchIntoFullscreen(full);
					this.sfdp = 1
				} else {
					this.exitFullscreen();
					this.sfdp = 0
				}
			},
			// 打开全屏
			launchIntoFullscreen(element) {
				// this.beforeDestroy()
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.webkitRequestFullscreen) {
					element.webkitRequestFullscreen();
				} else if (element.msRequestFullscreen) {
					element.msRequestFullscreen();
				}
				this.updateData()
			},
			// 退出
			exitFullscreen() {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				}
			},

			// 属性数据
			sfzxadd() {
				this.axios.get('/admin/sfzxa/rcdd', {
					token: true
				}).then(res => {
					this.sfzxa = res.data.data
				});
			},
			handleResize1(width, height) {
				this.myCharpath1.resize({
					width,
					height
				})
				this.myCharpath2.resize({
					width,
					height
				})
			},
			handleResize3(width, height) {
				this.myCharpath3.resize({
					width,
					height
				})
				this.myCharpath4.resize({
					width,
					height
				})
			},
			handleResize5(width, height) {
				this.myCharpath5.resize({
					width,
					height
				})
				this.myCharpath6.resize({
					width,
					height
				})
				this.myCharpath7.resize({
					width,
					height
				})
			},
			// handleResize8(width, height) {
			// 	this.myCharpath8.resize({
			// 		width,
			// 		height
			// 	})
			// 	this.myCharpath9.resize({
			// 		width,
			// 		height
			// 	})
			// 	this.myCharpath10.resize({
			// 		width,
			// 		height
			// 	})
			// },

			handleResize_kc(width, height) {
				this.myCharpath_kc7.resize({
					width,
					height
				})
				this.myCharpath_kc30.resize({
					width,
					height
				})
			},

			drawLine() {
				// 初始化echarts实例
				this.myCharpath1 = echarts.init(this.$refs.myCharpath1);
				this.myCharpath2 = echarts.init(this.$refs.myCharpath2);
				this.myCharpath3 = echarts.init(this.$refs.myCharpath3);
				this.myCharpath4 = echarts.init(this.$refs.myCharpath4);
				this.myCharpath5 = echarts.init(this.$refs.myCharpath5);
				// this.myCharpath6 = echarts.init(this.$refs.myCharpath6);
				// this.myCharpath7 = echarts.init(this.$refs.myCharpath7);
				// this.myCharpath8 = echarts.init(this.$refs.myCharpath8);
				// this.myCharpath9 = echarts.init(this.$refs.myCharpath9);
				// this.myCharpath10 = echarts.init(this.$refs.myCharpath10);
				this.myCharpath_kc7 = echarts.init(this.$refs.myCharpath_kc7);
				this.myCharpath_kc30 = echarts.init(this.$refs.myCharpath_kc30);
				// 顶部尺寸
				const resizeTarget1 = this.$refs.myCharpath1;
				// 创建 ResizeObserver 实例
				const resizeObserver1 = new ResizeObserver(entries => {
					// entries 是一个 ResizeObserverEntry 对象数组，包含目标元素的大小信息
					for (const entry of entries) {
						// 获取宽度和高度
						const {
							width,
							height
						} = entry.contentRect;
						console.log('Width:', width, 'Height:', height);

						// 在这里可以触发自定义的处理逻辑，例如将宽高信息传递给 Vue 组件的方法
						this.handleResize1(width, height);
					}
				});
				// 开始监听目标元素的大小变化
				resizeObserver1.observe(resizeTarget1);
				// 在组件销毁时停止监听，防止内存泄漏
				this.$once('hook:beforeDestroy', () => {
					resizeObserver1.disconnect();
				});

				// 中部1尺寸
				const resizeTarget3 = this.$refs.myCharpath3;
				// 创建 ResizeObserver 实例
				const resizeObserver3 = new ResizeObserver(entries => {
					// entries 是一个 ResizeObserverEntry 对象数组，包含目标元素的大小信息
					for (const entry of entries) {
						// 获取宽度和高度
						const {
							width,
							height
						} = entry.contentRect;
						console.log('Width:', width, 'Height:', height);

						// 在这里可以触发自定义的处理逻辑，例如将宽高信息传递给 Vue 组件的方法
						this.handleResize3(width, height);
					}
				});
				// 开始监听目标元素的大小变化
				resizeObserver3.observe(resizeTarget3);
				// 在组件销毁时停止监听，防止内存泄漏
				this.$once('hook:beforeDestroy', () => {
					resizeObserver3.disconnect();
				});

				// 底部1尺寸
				const resizeTarget5 = this.$refs.myCharpath5;
				// 创建 ResizeObserver 实例
				const resizeObserver5 = new ResizeObserver(entries => {
					// entries 是一个 ResizeObserverEntry 对象数组，包含目标元素的大小信息
					for (const entry of entries) {
						// 获取宽度和高度
						const {
							width,
							height
						} = entry.contentRect;
						console.log('Width:', width, 'Height:', height);

						// 在这里可以触发自定义的处理逻辑，例如将宽高信息传递给 Vue 组件的方法
						this.handleResize5(width, height);
					}
				});
				// 开始监听目标元素的大小变化
				resizeObserver5.observe(resizeTarget5);
				// 在组件销毁时停止监听，防止内存泄漏
				this.$once('hook:beforeDestroy', () => {
					resizeObserver5.disconnect();
				});

				// // 底部2尺寸
				// const resizeTarget8 = this.$refs.myCharpath8;
				// // 创建 ResizeObserver 实例
				// const resizeObserver8 = new ResizeObserver(entries => {
				// 	// entries 是一个 ResizeObserverEntry 对象数组，包含目标元素的大小信息
				// 	for (const entry of entries) {
				// 		// 获取宽度和高度
				// 		const {
				// 			width,
				// 			height
				// 		} = entry.contentRect;
				// 		console.log('Width:', width, 'Height:', height);

				// 		// 在这里可以触发自定义的处理逻辑，例如将宽高信息传递给 Vue 组件的方法
				// 		this.handleResize8(width, height);
				// 	}
				// });
				// // 开始监听目标元素的大小变化
				// resizeObserver8.observe(resizeTarget8);
				// // 在组件销毁时停止监听，防止内存泄漏
				// this.$once('hook:beforeDestroy', () => {
				// 	resizeObserver8.disconnect();
				// });

				// 一行2个模块
				const resizeTarget_kc = this.$refs.myCharpath_kc7;
				// 创建 ResizeObserver 实例
				const resizeObserver_kc = new ResizeObserver(entries => {
					// entries 是一个 ResizeObserverEntry 对象数组，包含目标元素的大小信息
					for (const entry of entries) {
						// 获取宽度和高度
						const {
							width,
							height
						} = entry.contentRect;
						console.log('Width:', width, 'Height:', height);

						// 在这里可以触发自定义的处理逻辑，例如将宽高信息传递给 Vue 组件的方法
						this.handleResize_kc(width, height);
					}
				});
				// 开始监听目标元素的大小变化
				resizeObserver_kc.observe(resizeTarget_kc);
				// 在组件销毁时停止监听，防止内存泄漏
				this.$once('hook:beforeDestroy', () => {
					resizeObserver_kc.disconnect();
				});


				// 配置参数
				// setTimeout(function() {
				this.myCharpath1.setOption(this.myCharpath1_a)
				this.myCharpath2.setOption(this.myCharpath2_a)
				this.myCharpath3.setOption(this.myCharpath3_a)
				this.myCharpath4.setOption(this.myCharpath4_a)
				this.myCharpath5.setOption(this.myCharpath5_a)
				// this.myCharpath6.setOption(this.myCharpath6_a)
				// this.myCharpath7.setOption(this.myCharpath7_a)
				// this.myCharpath8.setOption(this.myCharpath8_a)
				// this.myCharpath9.setOption(this.myCharpath9_a)
				// this.myCharpath10.setOption(this.myCharpath10_a)
				this.myCharpath_kc7.setOption(this.myCharpath_kc7a)
				this.myCharpath_kc30.setOption(this.myCharpath_kc30a)
				// }, 1000);
			},
		},

	};
</script>

<style>
	.j-center {
		justify-content: center;
	}

	.a-center {
		align-items: center;
	}

	.j-j {
		flex-flow: column;
	}

	.txtx {
		font-size: 14px;
		font-weight: 800;
		color: #535353;
	}

	.gdt::-webkit-scrollbar {
		width: 0;
	}

	.main {
		position: relative;
		background: url(../../../../image/background.jpg) no-repeat;
		background-size: cover;
	}

	.title_web {

		color: #0EFCFF;
		border: 1px solid #0EFCFF;

	}

	.title_admin {
		color: #0EFCFF;
		border: 1px solid #0EFCFF;
	}

	.chart_box {
		width: 100%;
		height: 100%;
	}

	.resize-target {
		width: 100%;
		height: 98%;
	}
</style>